module.exports = __webpack_public_path__ + "img/pe.44e49951.svg";